export const DRAFT_SCHEMA_VERSION = 1;
export const DRAFT_TTL_MS = 60 * 60 * 1000; // 1 hour

export const PRACTICE_STEP_CODE = 'self_scheduling__practice';
export const PRACTICE_SUBSTEP_CODE = 'self_scheduling__practice__selection';

export const PROVIDER_DATE_TIME_STEP_CODE = 'self_scheduling__provider_date_time';

export const PRACTICE_STEP = {
  code: PRACTICE_STEP_CODE,
  name: 'Practice',
  description: 'Pick a practice',
  substeps: [{ code: PRACTICE_SUBSTEP_CODE, name: 'Which practice would you like to book with?' }]
};

export const SELF_SCHEDULING_STEPS = [
  {
    code: PROVIDER_DATE_TIME_STEP_CODE,
    name: 'Provider, date & time',
    description: 'Pick a provider, date & time',
    substeps: [
      {
        code: 'self_scheduling__provider_date_time__selection',
        name: 'Choose a provider who offers the selected service.'
      }
    ]
  },
  {
    code: 'self_scheduling__insurance',
    name: 'Insurance',
    description: 'Enter insurance info',
    substeps: [
      {
        code: 'self_scheduling__insurance__form',
        name: 'How would you like to proceed for this appointment?'
      }
    ]
  },
  {
    code: 'self_scheduling__payment',
    name: 'Payment',
    description: 'Choose payment method',
    substeps: [
      {
        code: 'self_scheduling__payment__method',
        name: 'How would you like to pay for your visit?'
      }
    ]
  },
  {
    code: 'self_scheduling__personal_info',
    name: 'Personal info',
    description: 'Enter personal info',
    substeps: [
      {
        code: 'self_scheduling__personal_info__form',
        name: 'Enter your personal and contact details to confirm your appointment and send reminders.'
      }
    ]
  }
];
